export default {
  message: {},
};
